/**
 * useNewsletter Hook
 * Custom hook for accessing newsletter context
 */

import { useContext } from 'react';
import { NewsletterContext } from '../components/NewsletterProvider';
import type { NewsletterContextValue } from '../types';

/**
 * Hook to access newsletter functionality
 * Must be used within NewsletterProvider
 */
export function useNewsletter(): NewsletterContextValue {
  const context = useContext(NewsletterContext);

  if (!context) {
    throw new Error('useNewsletter must be used within a NewsletterProvider');
  }

  return context;
}
